import React from 'react';

/**
 * Footer text for upcoming sales table
 *
 * @constructor
 */
const UpcomingFooterText = () => (
    <div className="table-note">
        NOTE<br />
        Relatives in bold are stakes placed.<br />
        Click on horse to view lifetime record.<br />
        Data incorporates all racing in UK and Ireland, races at all Paris tracks in France,
        all Group races in Europe and Grade 1 races worldwide since 1988. Some other races abroad
        may also be included.
    </div>
);

export default UpcomingFooterText;



// WEBPACK FOOTER //
// ./src/js/components/UpcomingFooterText.js